import { render, staticRenderFns } from "./dropdown.vue?vue&type=template&id=f94f5d96&scoped=true&"
import script from "./dropdown.vue?vue&type=script&lang=js&"
export * from "./dropdown.vue?vue&type=script&lang=js&"
import style0 from "./dropdown.vue?vue&type=style&index=0&id=f94f5d96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94f5d96",
  null
  
)

export default component.exports